import React from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import S3Image from "screens/common/S3Image";
import { PopularFAs } from "screens/LoginRegistration/components/FAComponent/constants";
import FAGrid from "screens/LoginRegistration/components/FAComponent/FAGrid";
import NavHeader from "screens/LoginRegistration/utils/NavHeader";
import SClickableArea from "styled42/components/SClickableArea";
import SText from "styled42/components/SText";
import { pushClevertapEvent } from "utils/clevertapEvents";
import VernacManager from "utils/vernacular";

class FAGridView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleBackClick = () => {
    const { goBack, variant } = this.props;
    pushClevertapEvent(`loginRegister Clicks_${variant}`, {
      Page_Modal: "FA_Select",
      Type: "Back"
    });
    goBack();
  };

  handleMoreClick = () => {
    const { onViewModeChange, variant } = this.props;
    pushClevertapEvent(`loginRegister Clicks_${variant}`, {
      Type: "Show more categories"
    });
    pushClevertapEvent(`Reg Pop-up Load`, {
      Type: `Show more categories_${variant}`
    });
    onViewModeChange("LIST");
  };

  render() {
    const { selectedFAIds, onFASelectHandler } = this.props;

    return (
      <>
        <NavHeader
          progressStatus={3}
          containerStyle={styles.navheader}
          onBack={this.handleBackClick}
        />
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={styles.container}
        >
          <View style={styles.textContainer}>
            <SText size={18} weight="700">
              What types of jobs are you interested in?
            </SText>
            <SText size={12} weight="500" color="#09B885">
              {VernacManager.translateString(
                "edit_categories_select_3_categories"
              )}
            </SText>
          </View>
          <FAGrid
            faList={PopularFAs}
            gridKey="popular-grid"
            selectedFAIds={selectedFAIds}
            onSelect={onFASelectHandler}
          />
        </ScrollView>
        <SClickableArea
          onClick={this.handleMoreClick}
          containerStyle={styles.button}
        >
          <S3Image name="briefcase-purple" style={styles.icon} />
          <SText size={14} weight="500" color="#4727AD">
            More jobs
          </SText>
        </SClickableArea>
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#F7F8F9"
  },
  navheader: {
    backgroundColor: "#F7F8F9"
  },
  textContainer: {
    paddingTop: 20,
    paddingHorizontal: 16
  },
  button: {
    position: "absolute",
    bottom: 96,
    height: 32,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    paddingLeft: 20,
    paddingRight: 24,
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "#4727AD",
    borderRadius: 28
  },
  icon: {
    height: 20,
    width: 20,
    marginRight: 8
  }
});

export default FAGridView;
